import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputText from '../Common/InputText';
import Toggle from '../Common/Toggle/Toggle';
import DatePicker from '../Common/DatePicker/DatePicker';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';
import { DATE_FORMAT } from '../../constants/constants';
import Moment from 'moment';

export default class LocationForm extends Component {
    constructor(props, context) {
        super(props, context);
    }

    onFormChange = (e) => {
        this.props.onFormChange(e.target.name, e.target.value);
    }

    onSingleSelectBoxChange = (id, name) => {
        this.props.onFormChange(name, id.toString());
    }

    onMultiSelectBoxChange = (csv, name) => {
        const newValue = (csv) ? csv.split(",") : [];
        this.props.onFormChange(name, newValue);
    }

    onDateChange = (value, name) => {
        this.props.onFormChange(name, value);
    }

    onToggleChange = (name, value) => {
        this.props.onFormChange(name, value);
    }

    render() {
        return (
            <div className="location-form">
                <form noValidate className={this.props.isFormValid ? "" : "was-validated"}>
                    <div className="row">
                        <div className="col">
                            <InputText name="name" label="Location Name" placeholder="Location Name" type="text" value={this.props.location.name} onChange={this.onFormChange} isRequired={true} errorMessage="Location Name is required" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <InputText name="abbreviation" label="Location Abbreviation" placeholder="Location Abbreviation" type="text" value={this.props.location.abbreviation} onChange={this.onFormChange} isRequired={true} errorMessage="Location Abbreviation is required" />
                            <DatePicker showIcon name="openingDate" label="Opening Date" value={this.props.location.openingDate} onChange={this.onDateChange} isRequired={true} errorMessage="Opening Date is required" />
                            <InputText name="generalManagerName" label="General Manager Name" placeholder="General Manager Name" type="text" value={this.props.location.generalManagerName} onChange={this.onFormChange} />
                            <InputText name="generalManagerEmail" label="General Manager Email" placeholder="General Manager Email" type="email" value={this.props.location.generalManagerEmail} onChange={this.onFormChange} isValid={this.props.isGeneralManagerEmailValid} />
                            <InputText name="division" label="Division" placeholder="Division" type="text" value={this.props.location.division} onChange={this.onFormChange} />
                            <InputText name="unit" label="Unit" placeholder="Unit" type="text" value={this.props.location.unit} onChange={this.onFormChange} />
                        </div>
                        <div className="col-md-6">
                            <InputText name="generation" label="Generation" placeholder="Generation" type="text" value={this.props.location.generation} onChange={this.onFormChange} />
                            <InputText name="address" label="Address" placeholder="Address" type="text" value={this.props.location.address} onChange={this.onFormChange} />
                            <InputText name="city" label="City" placeholder="City" type="text" value={this.props.location.city} onChange={this.onFormChange} />
                            <InputText name="stateProvince" label="State/Province" placeholder="State/Province" type="text" value={this.props.location.stateProvince} onChange={this.onFormChange} />
                            <InputText name="billingInfo" label="Billing Info" placeholder="Billing Info" type="text" value={this.props.location.billingInfo} onChange={this.onFormChange} />
                            <MultiSelectBox
                                name="locationTagIds"
                                options={this.props.tags}
                                idField="id"
                                valueField="name"
                                selectedValues={this.props.location.locationTagIds.toString()}
                                onChange={this.onMultiSelectBoxChange}
                                isMulti={true}
                                label="Tags"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <MultiSelectBox name="brandId" label="Brand" idField="id" valueField="name"
                                options={this.props.brands}
                                onChange={this.onSingleSelectBoxChange}
                                defaultValue="Select a Brand"
                                selectedValues={this.props.location.brandId.toString()}
                                isRequired={true}
                                errorMessage="Brand is required"
                                isMulti={false}
                            />
                            <MultiSelectBox name="areaId" label="Area" idField="id" valueField="name"
                                options={this.props.areas}
                                onChange={this.onSingleSelectBoxChange}
                                defaultValue="Select an Area"
                                selectedValues={this.props.location.areaId.toString()}
                                isRequired={true}
                                errorMessage="Area is required"
                                isMulti={false}
                            />
                            <MultiSelectBox name="countryId" label="Country" idField="id" valueField="name"
                                options={this.props.countries}
                                onChange={this.onSingleSelectBoxChange}
                                defaultValue="Select a Country"
                                selectedValues={this.props.location.countryId.toString()}
                                isRequired={true}
                                errorMessage="Country is required"
                                isMulti={false}
                            />
                            <MultiSelectBox name="locationTypeId" label="Type" idField="id" valueField="name"
                                options={this.props.locationTypes}
                                onChange={this.onSingleSelectBoxChange}
                                defaultValue="Select a Type"
                                selectedValues={this.props.location.locationTypeId.toString()}
                                isRequired={true}
                                errorMessage="Type is required"
                                isMulti={false}
                            />
                        </div>
                        <div className="col-md-6">
                            <MultiSelectBox name="managementCompanyId" label="Management Company" idField="id" valueField="name"
                                options={this.props.managementCompanies}
                                onChange={this.onSingleSelectBoxChange}
                                defaultValue="Select a Management Company"
                                selectedValues={this.props.location.managementCompanyId.toString()}
                                isRequired={true}
                                errorMessage="Management Company is required"
                                isMulti={false}
                            />
                            <MultiSelectBox name="regionId" label="Region" idField="id" valueField="name"
                                options={this.props.regions}
                                onChange={this.onSingleSelectBoxChange}
                                defaultValue="Select a Region"
                                selectedValues={this.props.location.regionId.toString()}
                                isRequired={true}
                                errorMessage="Region is required"
                                isMulti={false}
                            />
                            <MultiSelectBox name="continentId" label="Continent" idField="id" valueField="name"
                                options={this.props.continents}
                                onChange={this.onSingleSelectBoxChange}
                                defaultValue="Select a Continent"
                                selectedValues={this.props.location.continentId.toString()}
                                isRequired={true}
                                errorMessage="Continent is required"
                                isMulti={false}
                            />
                            <MultiSelectBox name="projectManagerIds" label="Project Managers" idField="id" valueField="name"
                                options={this.props.projectManagers}
                                onChange={this.onMultiSelectBoxChange}
                                defaultValue="Select a Project Manager"
                                selectedValues={this.props.location.projectManagerIds.toString()}
                                isRequired={false}
                                isMulti={true} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <Toggle name="isActive" text="Active" checked={this.props.location.isActive} onChange={this.onToggleChange} />
                        </div>
                    </div>

                    {
                        this.props.location.id ?
                            <div>
                                <div className="row">
                                    <div className="col">
                                        {
                                            this.props.isUserEhAdmin ?
                                                <InputText name="id" isDisabled={true} label="Id" type="text" value={this.props.location.id.toString()} />
                                                :
                                                null
                                        }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <InputText name="createdByName" isDisabled={true} label="Created By" type="text" value={this.props.location.createdByName} />
                                        <InputText name="createdDate" isDisabled={true} label="Created Date" type="text" value={this.props.location.dateCreated} />
                                    </div>
                                    <div className="col-md-6">
                                        <InputText name="modifiedByName" isDisabled={true} label="Modified By" type="text" value={this.props.location.modifiedByName} />
                                        <InputText name="modifiedDate" isDisabled={true} label="Modified Date" type="text" value={this.props.location.dateModified} />
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }

                    {
                        this.props.trackingUpdates && this.props.trackingUpdates.length > 0 &&
                        <div>
                            <div className="mb-1"><strong>Opening Date Changes</strong></div>
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Old Value</th>
                                        <th>New Value</th>
                                        <th>Changed By</th>
                                        <th>Changed On</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.trackingUpdates.map(update =>
                                        <tr key={update.id}>
                                            <td>{Moment.utc(update.previousOpeningDate).format(DATE_FORMAT)}</td>
                                            <td>{Moment.utc(update.newOpeningDate).format(DATE_FORMAT)}</td>
                                            <td>{update.changedByName}</td>
                                            <td>{Moment.utc(update.changedDate).format(DATE_FORMAT)}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    }
                </form>
            </div>
        );
    }
}

LocationForm.propTypes = {
    isFormValid: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    isUserEhAdmin: PropTypes.bool.isRequired,
    areas: PropTypes.array.isRequired,
    brands: PropTypes.array.isRequired,
    continents: PropTypes.array.isRequired,
    countries: PropTypes.array.isRequired,
    locationTypes: PropTypes.array.isRequired,
    managementCompanies: PropTypes.array.isRequired,
    regions: PropTypes.array.isRequired,
    projectManagers: PropTypes.array.isRequired,
    onFormChange: PropTypes.func.isRequired,
    isGeneralManagerEmailValid: PropTypes.bool.isRequired,
    trackingUpdates: PropTypes.array,
    tags: PropTypes.array
}

